import React, { useState } from 'react';
import withRouter from '../../../../../services/util/withRouter';

import classes from './LCDComponent.module.css';

type Props = {
	lcdWidth: number,
	lcdHeight: number,
	lines: string[],
	backColor: String,
	foreColor: String
};

type States = {};

class LCDComponent extends React.Component<Props, States> {
	constructor(props) {
		super(props);
	}

	/**
	 * This function prepares the blocks for a single line of the LCD
	 * The blocks are fixed width, so if the line is shorter than the width,
	 * empty blocks are added
	 * 
	 * The colors could come from props or state in the future,
	 * but it was requested to be static for now
	 * @param {*} line 
	 * @returns 
	 */
	getBlocksForLine(line: string) {
		const blocks = [];
	
		for (let i = 0; i < this.props.lcdWidth; i++) {
			blocks.push(
				<div key={`lcd-char-${i}`} className={`${classes.lcdblock} lcd_font`} style={{ color: '#171717', border: '1px solid #d0d0d0' }}> 
					{i < line.length ? line.charAt(i) : ''}
				</div>
			);
		}
		
		return blocks;
	}

	render() {
		// Colors are not used currently, but could be in the future
		const {lines, backColor, foreColor } = this.props;
		
		const lcdLines = lines.map((line, idx) => (
			<div key={`lcd-line-${idx}`} className={classes.lcdline}>
				{this.getBlocksForLine(line)}		
			</div>
		));
		return (
			<>
				<div
                    className={classes.lcdbackground}
					style={{
						backgroundColor: '#c8c8c8',						
					}}
				>
					{lcdLines}
				</div>
			</>
		);
	}
}

export default withRouter(LCDComponent);
